import { cva } from 'class-variance-authority';

export const containerVariants = cva(
  'group h-full relative flex bg-white border-gray-300 border md:border md:rounded-md overflow-hidden',
  {
    variants: {
      imagePosition: {
        left: 'flex-col md:!flex-row',
        top: '!rounded-md !flex-col',
      },
      layout: {
        default: 'flex-col md:flex-row rounded-md',
        halfImage: '',
        noImage:
          'flex-col !border-x-[transparent] !border-t-[transparent] !rounded-none md:!rounded-md md:!border-x-gray-300 md:!border-t-gray-300',
        noImageMobile:
          'flex-col !border-x-[transparent] !border-t-[transparent] !rounded-none md:!rounded-md md:!border-x-gray-300 md:!border-t-gray-300',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
      layout: 'default',
    },
  }
);

export const titleVariants = cva(
  'text-[1.05rem] md:line-clamp-2 md:text-[1.25rem] font-bold mt-2 mb-1.5 tracking-tighter leading-6 md:leading-5.5 capitalize',
  {
    variants: {
      imagePosition: {
        left: '',
        top: 'md:line-clamp-2',
      },
      layout: {
        default: '',
        halfImage: '',
        noImage: 'md:max-w-[calc(100%-34px)]',
        noImageMobile: '',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
      layout: 'default',
    },
  }
);

export const lockVariants = cva('', {
  variants: {
    imagePosition: {
      left: 'hidden md:block',
      top: 'hidden md:block',
    },
    layout: {
      default: '',
      halfImage: '',
      noImage: 'absolute right-3 !left-[unset] top-0',
      noImageMobile: '',
    },
  },
  defaultVariants: {
    imagePosition: 'left',
    layout: 'default',
  },
});

export const imageContainerVariants = cva('block rounded-t-md md:rounded-none overflow-hidden relative min-h-[120px]', {
  variants: {
    imagePosition: {
      left: 'md:basis-[30%] min-w-[150px]',
      top: 'md:min-h-[200px]',
    },
    layout: {
      default: '',
      halfImage: 'md:!h-[calc(50%-14px)] md:!min-h-[calc(50%-14px)]',
      noImage: 'hidden',
      noImageMobile: 'hidden md:block',
    },
  },
  defaultVariants: {
    imagePosition: 'left',
    layout: 'default',
  },
});

export const contentContainerVariants = cva('w-auto h-[inherit] p-4 py-2 pb-3 md:flex md:flex-col', {
  variants: {
    layout: {
      default: 'md:basis-[70%]',
      halfImage: '',
      noImage: '!basis-full',
      noImageMobile: 'basis-full md:basis-[70%]',
    },
  },
  defaultVariants: {
    layout: 'default',
  },
});

export const summaryVariants = cva(
  'text-gray-500 hidden text-sm  md:[--webkit-box] md:mt-1 md:text-[1.025rem] leading-[1.35rem]',
  {
    variants: {
      imagePosition: {
        left: 'md:line-clamp-2',
        top: 'md:line-clamp-3',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
    },
  }
);
